import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { DndContext } from '@dnd-kit/core'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import { ChildProps } from '~/common/define/props'
import { DragEndEvent } from '@dnd-kit/core/dist/types'
import { Model } from '~/common/utils/model'

export interface SortableModel extends Model {
  id: number
}

interface SortableIndexModel extends SortableModel {
  index: number
}

interface Props extends ChildProps {
  items: SortableModel[]
  onDragEnd(items: SortableModel[]): void
  disabled?: boolean
}

const addIndexToItems = (items: SortableModel[]): SortableIndexModel[] => {
  return items.map((item, index) => {
    return {
      ...item,
      index
    }
  })
}

const Sortable = ({children, items, onDragEnd, disabled = false}: Props) => {
  const [sortableItems, setSortableItems] = useState<SortableIndexModel[]>(addIndexToItems(items))
  const handleDragEnd = useCallback((event: DragEndEvent) => {
    const { active, over } = event
    if (over === null) {
      return
    }
    if (active.id !== over.id) {
      const oldIndex = items
        .map((item) => {
          return item.id
        })
        .indexOf(active.id as number)
      const newIndex = items
        .map((item) => {
          return item.id
        })
        .indexOf(over.id as number)
      setSortableItems(arrayMove(sortableItems, oldIndex, newIndex))
      onDragEnd(arrayMove(items, oldIndex, newIndex))
    }
  }, [items])

  useEffect(() => {
    setSortableItems(addIndexToItems(items))
  }, [items])

  const childArray = React.Children.toArray(children)

  return (
    <>
      <DndContext onDragEnd={handleDragEnd}>
        <SortableContext
          items={sortableItems}
          strategy={verticalListSortingStrategy}
          disabled={disabled}
        >
          {sortableItems.map((item) =>
            <Fragment key={item.id}>{childArray[item.index]}</Fragment>
          )}
        </SortableContext>
      </DndContext>
    </>
  )
}

export default Sortable